import React, { useContext } from "react"
import { getDateFormat } from "../../helper"
import { useParams } from "react-router-dom"
import NewsDetailSkeleton from "./NewsDetailSkeleton"
import { useFetchApi } from "../../hooks"
import NotFound from "../NotFound/NotFound"
import { LangContext } from "../../LangProvider"

function Content() {
  const { id } = useParams()
  const { lang } = useContext(LangContext)
  const [{ data: article, loading, error }] = useFetchApi(`/news/${id}`, {})

  if (error) {
    return <NotFound />
  }
  return (
    <>
      {loading ? (
        <NewsDetailSkeleton />
      ) : (
        <article className="uk-article uk-container uk-margin-large-bottom">
          <h1 className="uk-article-title">{article.title[lang]}</h1>
          <img src={article.image} alt={article.title[lang]} />
          <p className="uk-article-meta">
            Written by Admin on {getDateFormat(article.createdAt)}.
          </p>

          <div dangerouslySetInnerHTML={{ __html: article.body[lang] }}></div>
        </article>
      )}
    </>
  )
}

export default Content
